import React from 'react';

const callToWork = props => {
    const formatText = text => {
        if (props.name.chosen) {
            text = text.replace(
                '[vriend]',
                `<span class="name">${props.name.name}</span>`
            );
        } else {
            text = text.replace('[vriend]', '');
        }
        return text;
    };

    const ShowAvatar = () => {
        const avatar = props.avatar.user_avatar;
        return (
            avatar && (
                <div
                    className="callto__avatar"
                    dangerouslySetInnerHTML={{ __html: avatar }}
                />
            )
        );
    };

    const ShowUserDetails = () => {
        const { title, text, phone, email } = props;
        return (
            <div className="callto__inner">
                {title && (
                    <h3
                        className="callto__title"
                        dangerouslySetInnerHTML={{
                            __html: formatText(title),
                        }}
                    />
                )}

                {text && (
                    <span
                        className="callto__caption"
                        dangerouslySetInnerHTML={{
                            __html: 'Call or email&nbsp;' + formatText(text),
                        }}
                    />
                )}

                {phone && (
                    <span className="callto__phone">
                        <a href={`tel:${phone}`}>+{phone}</a>
                    </span>
                )}

                {email && (
                    <span className="callto__email">
                        <a href={`mailto:${email}`}>{email}</a>
                    </span>
                )}
            </div>
        );
    };

    const CallToWorkContent = () => (
        <div className="callto">
            <div className="content-container">
                <div className="callto__link-banner">
                    <ShowAvatar />
                    <ShowUserDetails />
                </div>
            </div>
        </div>
    );

    return <CallToWorkContent />;
};
export default callToWork;



// WEBPACK FOOTER //
// ./src/components/Pages/Work/CallToWork.jsx